import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface CombinedLoadingState {
  hasError: boolean;
  isLoading: boolean;
  hasLoaded: boolean;
  errors: DetailedErrorInfo[];
}

export interface LoadingStateWithTraceId {
  isLoading: boolean;
  hasError: boolean;
  hasLoaded: boolean;
  error: DetailedErrorInfo | null;
}

interface DetailedErrorInfo {
  code: number;
  message: string;
  errorInfo?: { message: string; detailedMessage: string; traceId: string };
}

export const combineLoadingStates = (
  loadingStates$: Observable<LoadingStateWithTraceId>[],
) =>
  combineLatest(loadingStates$).pipe(
    map((_loadingStates) => {
      const errors = _loadingStates
        .map((state) => state.error)
        .filter((error) => error != null);
      return <CombinedLoadingState>{
        hasError: errors.length > 0,
        errors,
        hasLoaded: _loadingStates.every((state) => state.hasLoaded),
        isLoading: _loadingStates.some((state) => state.isLoading),
      };
    }),
  );
